import React from "react";
import { useCustomer } from "../../hooks/useCustomers";

interface CustomerNameProps {
  customerId: string;
  fallback?: string;
}

export const CustomerName: React.FC<CustomerNameProps> = ({
  customerId,
  fallback = "Unknown Customer",
}) => {
  const { data: customerData, isLoading } = useCustomer(customerId);
  const customer = customerData?.customer;

  if (isLoading) {
    return <span className="text-slate-400">Loading...</span>;
  }

  if (!customer) {
    return <span className="text-slate-500">{fallback}</span>;
  }

  return (
    <div className="flex items-center">
      <div className="flex-shrink-0 h-8 w-8">
        <div className="h-8 w-8 rounded-full bg-green-600 flex items-center justify-center">
          <span className="text-xs font-medium text-white">
            {customer.name.charAt(0).toUpperCase()}
          </span>
        </div>
      </div>
      <div className="ml-3">
        <div className="text-sm font-medium text-white">{customer.name}</div>
        <div className="text-xs text-slate-400">{customer.playerId}</div>
      </div>
    </div>
  );
};
